// Author YuJiaBei
// Date 2020-10-10 14:00:25

import * as model from "@/model/sithMes/mst/SithMesMstUserPositionModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstUserPosition(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .buildStore()
